const API_BASE_URL = 'https://saudidemobill-4qzv.onrender.com/api';

export default API_BASE_URL;
